<template>
  <div class="panel-admin-body">
    <div class="d-flex title">
      <modal-link modal-id="How to Use"></modal-link>Trends
      <smart-center-link page="Trends" location="Header" />
      <div class="ml-auto">
        <span class="wizard-icon">
          <font-awesome-icon v-tooltip="tooltipConfigShow" :icon="['fas', 'hat-wizard']"
            @click="$root.toggleWizardContent()" />
        </span>
        <i v-show="this.$parent.displayShowMenuIcon && this.$root.getShowHeaderMenu()"
          class="fa fa-window-minimize pl-1 pr-1" aria-hidden="true" @click="$parent.toggleHeaderMenu()"></i>
        <i v-show="this.$parent.displayShowMenuIcon && !this.$root.getShowHeaderMenu()"
          class="fa fa-window-maximize pl-1 pr-1" aria-hidden="true" @click="$parent.toggleHeaderMenu()"></i>
      </div>
    </div>
    <chart-menu></chart-menu>
    <div v-show="$root.getShowWizardContent()" class="wizard-content">
      <div class="wizard-content-column-two-entries wizard-border col-3">
        <div class="w-100 d-flex">
          <div class="circle">1</div>
          <div class="wizard-text">
            Click Metric to select the set of Growth
            data to trend against your company’s
            performance. Note: To add Growth data,
            contact your wRatings Advisor.
          </div>
        </div>
        <div class="w-100 d-flex pt-2">
          <div class="circle">2</div>
          <div class="wizard-text">
            Click Performance to select which set of
            data to trend. Click Start Period to specify
            which Wave to begin showing trends.
            Note: To modify Waves, contact your
            wRatings Advisor.
          </div>
        </div>
      </div>
      <div class="wizard-content-column-two-entries wizard-border col-3">
        <div class="w-100 d-flex">
          <div class="circle">3</div>
          <div class="wizard-text">
            Click Groups to override the current survey
            selected for Trends. To run Trends for the
            current survey, select None. Note: To
            modify Groups, contact your wRatings
            Advisor.
          </div>
        </div>
        <div class="w-100 d-flex  pt-2">
          <div class="circle">4</div>
          <div class="wizard-text">
            Click the box to include partial responses,
            which are respondents that did not
            complete all the survey fields.
          </div>
        </div>
      </div>
      <div class="wizard-content-column wizard-border col-3">
        <div class="w-100 d-flex">
          <div class="circle">5</div>
          <div class="wizard-text">
            Click up to 5 competitors
            to include in your Profiles.
            Click the Benchmarks to compare
            your data to any of our
            well-recognized
            companies.
          </div>
        </div>
      </div>
      <div class="wizard-content-column-two-entries col-3">
        <div class="w-100 d-flex">
          <div class="circle">6</div>
          <div class="wizard-text">
            Segments are created through your survey
            questions. Click any segment criteria to
            select which respondents to include in your
            Profile. Selecting no criteria includes all
            respondents for that question. Segments
            for NPS, Location and Word are included as
            defaults.
          </div>
        </div>
        <div class="w-100 d-flex pt-2">
          <div class="circle">7</div>
          <div class="wizard-text">
            Click Generate Chart to build your Profile.
            Click Reset to start the build process from
            scratch.
          </div>
        </div>
      </div>
    </div>
    <div class="chart-app">
      <chart-criteria ref="chartCriteria" :show-custom-time-period="false" :show-metric="true" :show-display-type="true"
        display-type-label="Performance" display-type-modal-name="Performance" time-period-label="Start Period" :is-comparative="false"></chart-criteria>
      <div class="row no-gutters">
        <div class="col">
          <div id="chartDislayCard">
            <div id="performance_dashboard">
              <div v-show="generatingChart" class="chart-overlay">Generating Chart...</div>
              <div id="chart-filters" class="row">
                <chart-criteria-results ref="chartCriteriaResults" v-bind:criteria-results-list="criteriaResultsList"
                  v-bind:criteria-results-company-list="criteriaResultsCompanyList"></chart-criteria-results>
              </div>
              <GChart :settings="{ packages: ['corechart', 'controls'] }" style="display: none" type="LineChart"
                @ready="onChartReady" />
              <GChart :settings="{ packages: ['corechart', 'controls'] }" style="display: none" type="BarChart"
                @ready="onChartReady" />
              <div v-show="getDisplayView()" class="row mt-3 mb-3">
                <div class="col-lg-12">
                  <button id="save_chart" class="btn btn-primary ml-2" type="button"
                    @click="$modal.show('save-chart-confirmation')" :disabled="disableSaveAsCardButton">Save as
                    Card</button>
                </div>
              </div>

              <MoatTrend v-show="isMoatTrend" :chart-data="chartData"></MoatTrend>
              <div v-show="!isMoatTrend" id="chart-container" class="row">
                <div id="competitive-trends-chart" class="competitive-trends col-12">
                  <div id="competitive-trends-title-and-chart" class="title-and-chart">
                    <div class="title-and-chart-left">
                      <div class="chart-title-container" v-show="getDisplayView()">
                        <h4 class="text-primary">
                          {{ chart.title }}
                          <smart-center-link v-if="showSummarySmartCenterLink" page="Trends"
                            location="Trends by Summary" />
                          <smart-center-link v-if="!showSummarySmartCenterLink" page="Trends"
                            location="Trends by Needs" />
                        </h4>
                      </div>
                      <chart-legend v-if="!showNpsTrends()" :class="getLegendClass('pt-4')" height="auto"
                        :direction="'vertical'" :width="'auto'" location="Trends" :elements="legendElements"
                        @redraw="showOrHideElements">
                      </chart-legend>
                    </div>
                    <div class="buttons-and-chart">
                      <chart-buttons :display="getDisplayView()" :tooltip-configuration="snapChartTooltipConfig"
                        :snap-container-id="'competitive-trends-title-and-chart'"
                        :container-id="'competitive-trends-chart'" :report-page-type-name="'Chart - Competitive Trends'"
                        :insight-modal-id="'competitive-trends-chart'" :text-direction="this.textDirection"
                        :include-text-direction="!showNpsTrends()">
                      </chart-buttons>
                      <div id="competitive-trends" class="chart"></div>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div v-show="!showNpsTrends() && getDisplayView()" :id="tableContainerId"
                    class="chart-data">
                    <chart-data-table 
                      ref="competitiveTrendsDataTable"
                      :chart-data="table.data" :container-id="'competitive-trends'"
                      :data-container-id="tableContainerId" :column-defs="this.chart.columnDefs"
                      :table-class="'table display row-border table-hover'" :table-width="'auto'"
                      :table-title="tableTitle" :report-page-type-name="'Table - Competitive Trends'"
                      :insight-modal-id="'competitive-trends-table'"></chart-data-table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-for="(pageContent, idxPageContent) in pageContent" v-bind:key="idxPageContent">
        <modal :modal-id="pageContent.title" :modal-title="pageContent.title"
          :modal-content="pageContent.contentText" />
      </div>
      <vue-modal name="save-chart-confirmation" :width="350" :height="200">
        <save-chart :chart-title="this.chart.title" :initial-client-chart="this.clientChart"
          @save="updateClientCharts"></save-chart>
      </vue-modal>
      <insights ref="insightsChart" :modal-name="'competitive-trends-chart'"
        :report-page-type-name="'Chart - Competitive Trends'" :entry-page-content="this.pageContentForReport"
        @saveReportPage="updateReportPages" @saveAllReportPages="saveAllReportPages"
        @saveClientChart="saveClientChart" />
      <insights ref="insightsTable" :modal-name="'competitive-trends-table'"
        :report-page-type-name="'Table - Competitive Trends'" :entry-page-content="this.pageContentForReport"
        @saveReportPage="updateReportPages" @saveAllReportPages="saveAllReportPages"
        @saveClientChart="saveClientChart" />
    </div>
  </div>
</template>
<script>
import $ from "jquery";

import ChartCompanyMixins from "../../mixins/ChartCompanyMixins.vue";
import ChartLegend from "../../components/chart/ChartLegend.vue";
import ChartButtons from "../../components/chart/ChartButtons.vue";
import MoatTrend from "./type/MoatTrend.vue";

import SaveChart from "../../components/chart/SaveChart.vue";
import ChartService from "../../services/chart.service";
import ErrorService from "../../services/error.service";
import AdminService from "../../services/admin.service";
import TableService from "../../services/table.service";
import ReportService from "../../services/report.service";
import ContentService from "../../services/content.service";

export default {
  name: "CompetitiveTrends",
  mixins: [ChartCompanyMixins],
  components: {
    SaveChart,
    ChartLegend,
    ChartButtons,
    MoatTrend
  },
  data() {
    return {
      title: "Trends",
      tableContainerId: "competitive-trends-data-container",
      pageNumber: 3,
      periodPrefix: "Start",
      primaryChart: {},
      legendElements: [],
      chartData: {},
      redrawAdditionalWidgets: true,
      competitiveTrendsOptions: {},
      emotionalNeedSelected: false,
      insightModalId: "",
      textDirection: "horizontal",
      isMoatTrend: false
    };
  },
  methods: {
    displayInsights(insightModalId, reportPageTypeName) {
      if (reportPageTypeName == "Chart - Competitive Trends") {
        this.$refs.insightsChart.reportPageInput = ReportService.getReportPage(reportPageTypeName, this.reportPagesList);
        this.$refs.insightsChart.initializeInsights(this.clientChart);
        this.$modal.show(insightModalId);
      } else if (reportPageTypeName == "Table - Competitive Trends") {
        this.$refs.insightsTable.reportPageInput = ReportService.getReportPage(reportPageTypeName, this.reportPagesList);
        this.$refs.insightsTable.initializeInsights(this.clientChart);
        this.$modal.show(insightModalId);
      }
    },
    onChartReady(chart, google) {
      this.chartsLib = google;
      this.primaryChart = new google.visualization.ChartWrapper({
        chartType: "LineChart",
        containerId: "competitive-trends"
      });
      this.npsChart = new google.visualization.ChartWrapper({
        chartType: "ColumnChart",
        containerId: "competitive-trends"
      });
    },
    async drawNPSChart(data, containerId) {
      let npsChartOptions = ChartService.getChartOptions("nps_trends_chart");
      let npsChartData = ChartService.buildNpsTrendsChartData(data, this.chartsLib);
      await ChartService.paintChart(this.npsChart, containerId, npsChartOptions, npsChartData, this);
      this.resetLegendElements();
    },
    async displayChartCallback(response) {
      try {
        if (this.$refs.chartCriteria.$data.textDirection != ""){
          this.textDirection = this.$refs.chartCriteria.$data.textDirection;
        }
        this.$root.processServerResponse();
        this.generatingChart = false;
        /* eslint no-empty: ["error", { "allowEmptyCatch": true }] */
        try{this.primaryChart.getChart().clearChart();} catch(e){}
        /* eslint no-empty: ["error", { "allowEmptyCatch": true }] */
        try{this.npsChart.getChart().clearChart();} catch(e){}

        let returnData = response.data;
        this.chartData = returnData[0];
        let chartDataToDisplay = JSON.parse(JSON.stringify(this.chartData));
        this.redrawAdditionalWidgets = true;
        let otherData = chartDataToDisplay["otherData"];
        if (typeof otherData["isMoatTrends"] != "undefined") {
          this.isMoatTrend = otherData["isMoatTrends"];
        } else {
          this.isMoatTrend = false;
        }
        if (this.isMoatTrend) {
          this.chartData = response.data;
          return;
        }

        this.legendElements = otherData["legend"];
        this.emotionalNeedSelected = otherData["emotionalNeedSelected"];
        let companyColorList = otherData["companyColorList"];
        TableService.setCompanyColorList(companyColorList);
        let breakPointList = otherData["breakPointList"];
        ChartService.setVerticalLineBreakPoints(breakPointList);

        let dynamicChartOptions = chartDataToDisplay["options"];
        this.chart.title = typeof dynamicChartOptions.title != "undefined" ? dynamicChartOptions.title : "Summary";
        let containerId = chartDataToDisplay["containerId"];

        if (this.showNpsTrends()) {
          let npsChartDataByTimePeriod = otherData["npsChartDataByTimePeriod"];
          this.drawNPSChart(npsChartDataByTimePeriod, containerId);
        } else {
          let chartOptions = ChartService.getChartOptions(containerId);
          $.extend(chartOptions, dynamicChartOptions);
          let vAxisForMetric = otherData["vAxisForMetric"];
          let vAxisForPerformance = otherData["vAxisForPerformance"];
          let overrideTicks = otherData["overrideTicks"];
          if (overrideTicks == true) {
            vAxisForPerformance.ticks = 'auto';
          }
          $.extend(chartOptions.vAxes[0], vAxisForPerformance);
          $.extend(chartOptions.vAxes[1], vAxisForMetric);
          let usePercentage = otherData["usePercentage"];
          let useCurrency = otherData["useCurrency"];
          if (useCurrency == true || useCurrency == "true") {
            $.extend(this.chart.columnDefs[2], TableService.getDollarTableAttribute([1], "dt-right chart-light-green", 75, 2));
          } else if (usePercentage == false) {
            $.extend(this.chart.columnDefs[2], TableService.getNumericTableAttribute([1], "dt-right chart-light-green", 75, 2));
          } else {
            $.extend(this.chart.columnDefs[2], TableService.getPercentTableAttribute([1], "dt-right chart-light-green", 75, 2));
          }
          this.setChartResults(chartDataToDisplay.companyList);
          this.criteriaResultsList = AdminService.removeByName(chartDataToDisplay.criteriaList, "Competitor");
          this.table.id = containerId;
          this.table.data = chartDataToDisplay;
          this.competitiveTrendsOptions = JSON.parse(JSON.stringify(chartOptions));
          this.competitiveTrendsOptions = ChartService.setHAxisFormat(this.textDirection, this.competitiveTrendsOptions);
          chartDataToDisplay = this.drawTimePeriodName(chartDataToDisplay);

          await ChartService.paintChart(this.primaryChart, containerId, this.competitiveTrendsOptions, chartDataToDisplay, this);
        }
        this.resetLegendElements();
        this.$root.$emit("check-number-of-responses");
        this.setDisplayView(true);
        this.$root.processServerResponse();
      } catch (err) {
        ErrorService.processException("CompetitiveTrends.displayChartCallback", err, "chart", this);
      }
    },
    async smartRedrawChart(generatedChart) {
      generatedChart.find(".vertical-line").remove();
      this.prePaintChart(true);
    },
    async prePaintChart(redrawWidgets) {
      this.redrawAdditionalWidgets = redrawWidgets;
      let chartDataToPrint = JSON.parse(JSON.stringify(this.chartData));
      chartDataToPrint = this.drawTimePeriodName(chartDataToPrint);
      await ChartService.paintChart(this.primaryChart, this.table.id, this.competitiveTrendsOptions, chartDataToPrint, this);
    },
    async showOrHideElements(element) {
      if (element.visible == true) {
        this.competitiveTrendsOptions.series[element.seriesNumber].lineWidth = 5;
        if (element.elementId == "thick") {
          this.competitiveTrendsOptions.series[element.seriesNumber].type = "bars";
        }
      } else {
        if (element.elementId == "thick") {
          this.competitiveTrendsOptions.series[element.seriesNumber].type = "line";
          this.competitiveTrendsOptions.series[element.seriesNumber].pointSize = 0;
        }
        this.competitiveTrendsOptions.series[element.seriesNumber].lineWidth = 0;
      }
      this.prePaintChart(false);
    },
    async setXAxisTextDirection(containerId, direction) {
      if (typeof this.$refs.chartCriteria != "undefined"){
	  	  this.$refs.chartCriteria.setTextDirection(direction);
	    }      
      this.competitiveTrendsOptions = ChartService.setHAxisFormat(direction, this.competitiveTrendsOptions);
      this.textDirection = direction;
      this.prePaintChart(true);
    },
    postPaintChart(primary_chart, containerId, options, dataTable) {
      var chartContainer = $("#competitive-trends");
      if (!this.showNpsTrends()) {
        let chartInterface = primary_chart.getChartLayoutInterface();

        let chartBase = {
          width: 0,
          left: 1,
          top: 5,
          height: chartInterface.getChartAreaBoundingBox().height
        };
        let verticalLine = {
          top: chartBase.top,
          height: chartBase.height,
          left: chartBase.left
        };
        let gap = (chartInterface.getXLocation(1) - chartInterface.getXLocation(0)) / 2;
        let competitiveTrendsVerticalLineIndex = ChartService.getVerticalLineBreakPoints();
        //Draw the special symbols X and -
        let className = "vertical-line";
        for (var index = 0; index < dataTable.getNumberOfRows(); index++) {
          if (this.redrawAdditionalWidgets == true && typeof competitiveTrendsVerticalLineIndex != "undefined" && competitiveTrendsVerticalLineIndex.includes(index)) {
            let xPos = chartInterface.getXLocation(index) + verticalLine.left + gap;
            chartContainer.append(ChartService.paintVerticalLine(verticalLine.top, xPos, verticalLine.height, className));
          }
        }
        if (this.emotionalNeedSelected) {
          let horizontalLine = {
            top: 226.6,
            left: chartBase.left
          };
          let horizontalLineLeft = chartInterface.getChartAreaBoundingBox().left + horizontalLine.left;
          chartContainer.append(ChartService.paintHorizontalLine(horizontalLine.top, horizontalLineLeft, chartInterface.getChartAreaBoundingBox().width, "horizontal-line"));
        }
        ChartService.positionChartButtons(chartInterface, chartContainer.parent().parent());
      }
      chartContainer.parent().parent().addClass("chart-wrapper");
      this.saveReportPage(containerId);
    },
    async saveReportPage(containerId) {
      if (this.clientChart.clientChartId != 0  && this.isGenerateReportRunning()) {
        let reportPageChart = $("#" + containerId);
        let reportPageChartObject = reportPageChart[0];
        let imageReportPageChartContent = await this.createChartImage(reportPageChartObject, false, true);
        await ReportService.saveReportPage(imageReportPageChartContent, "Chart - Competitive Trends", this.clientChart, this.saveReportPageCallback, this);
        await ReportService.saveReportPageFile(this.imageUrl, "png", "Chart - Competitive Trends", this.clientChart, this.saveReportPageCallback, this);
/*
        let tableContainerId = this.tableContainerId;
        let reportPageTableName = "Table - Competitive Trends";
        let imageReportPageTableContent = await this.createTableImage(this, tableContainerId, false, 750, 10); 
        await ReportService.saveReportPage(imageReportPageTableContent, reportPageTableName, this.clientChart, this.saveReportPageCallback, this);
        await ReportService.saveReportPageFile(this.tableImageUrl, "png", reportPageTableName, this.clientChart, this.saveReportPageFileCallback, this);
*/
        
        await ReportService.saveReportTableFile(
          this.$refs.competitiveTrendsDataTable.getTableData(),
          "Table - Competitive Trends", 
          this.clientChart, 
          this.saveReportTableFileCallback, 
          this
        );

        await ReportService.saveReportPage(
          this.getReportTableContent(containerId), 
          "Table - Competitive Trends", 
          this.clientChart, 
          this.saveReportPageCallback, 
          this
        );
      }
    },
    saveAllReportPages() {
      this.saveReportPage("competitive-trends");
    },
    drawTimePeriodName(inputChartData) {
      for (let indexRows = 0; indexRows < inputChartData.rows.length; indexRows++) {
        let chartDataRow = inputChartData.rows[indexRows].c;
        let value = chartDataRow[0].v;
        if (typeof value != "undefined") {
          let position = value.indexOf("(");
          let firstPart = value.substring(0, position);
          chartDataRow[0].v = firstPart;
        }
      }
      return inputChartData;
    },
    getLegendClass: function (legendClass) {
      if (this.getDisplayView()) {
        legendClass += " visible";
      } else {
        legendClass += " invisible";
      }
      return legendClass;
    },
    showNpsTrends: function () {
      if (typeof this.$refs.chartCriteria != "undefined" &&
        typeof this.$refs.chartCriteria.showNpsTrends != "undefined") {
        return this.$refs.chartCriteria.showNpsTrends;
      }
      return false;
    }
  },
  destroyed() { },
  computed: {
    tableTitle: function () {
      return "<h4 class='text-primary'>" + this.chart.title + "</h4>";
    },
    showSummarySmartCenterLink: function () {
      return true;
    }
  },
  props: {},
  mounted() {
    let vm = this;
    $(window).smartresize(function () {
      if (!vm.showNpsTrends()) {
        vm.smartRedrawChart($("#competitive-trends"));
      }
    });
  },
  created() {
    this.chart = ChartService.getChartAttributes("Trends");
  },
  watch: {}
};
</script>
